module.exports = __webpack_public_path__ + "img/icon_chatbot_orange.9a6eb539.svg";